import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Features } from '../components/Features';
import { Rules } from '../components/Rules';
import { Organization } from '../components/Organization';
import { Pricing } from '../components/Pricing';
import { AtmosphereStrip } from '../components/AtmosphereStrip';
import { Gallery } from '../components/Gallery';
import { CTA } from '../components/CTA';
export function Home() {
  return <main data-id="element-292" data-mp="24h0rq3j7379z">
      <Hero data-id="element-293" data-mp="24gsajzg1hfsz" />
      <About data-id="element-294" data-mp="24g8u6n61ezh2" />
      <Features data-id="element-295" data-mp="24i3j0ckfjbqf" />
      <Rules data-id="element-296" data-mp="24hk6jbdjtfjs" />
      <Organization data-id="element-297" data-mp="24j4s4bhvxo5i" />
      <Pricing data-id="element-298" data-mp="29g4yyomk6uxo" />
      <AtmosphereStrip data-id="element-299" data-mp="29flpzxevzgvs" />
      <Gallery data-id="element-300" data-mp="29fc009tud9q3" />
      <CTA data-id="element-301" data-mp="29ek6d4jt1m2g" />
    </main>;
}